import React, { useState, useEffect } from 'react';
import { handleApiExceptions, generate_query_set, goTo, alertify } from '../../../app_methods';
import { ContentCard, PaginationKaBaap } from '../../Common';
import { EaseTable } from '../../../libs/EaseTable';
import { isMobile } from 'react-device-detect';
import { getLedgerTableColumns, ledgerTableFilterNodes } from './constants';
import { Ledger, Merchant } from '../../../models';
import { LedgerDrawer } from '../DetailsDrawer';
import { connect } from 'react-redux';
import './index.scss';
import { PermissionHoc } from '../../HOC';
import moment from 'moment';
import { Icon } from 'antd';


const LedgerList = (props) => {
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [filters, setFilters] = useState({});
    const [ledgerData, setLedgerData] = useState([]);
    const [showLedgerDrawer, setShowLedgerDrawer] = useState(false);
    const [activeLedger, setActiveLedger] = useState({});
    const [isDownloading, setIsDownloading] = useState(false);
    const [totalPage, setTotalPage] = React.useState(0);
    const [currentVirtualAccount, setCurrentVirtualAccount] = useState((props.current_user.virtual_accounts || []).find(x => x.active) || {});
    const permissions = props.current_user.user.permissions;
    const [virtualAccounts, setVirtualAccounts] = useState(props.current_user.virtual_accounts || []);

    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.created_at && _filters.created_at.length) {
            _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
            _filters.created_at_end = moment().isBefore(_filters.created_at[1])?moment().format("YYYY-MM-DD"):_filters.created_at[1].format("YYYY-MM-DD");
            delete _filters.created_at;
        }
        return _filters;
    };

    const fetchLedgerData = async (_pagination, _filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await Ledger.list({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        setLedgerData(generate_query_set(Ledger, response.data.results));
        setPagination({ ..._pagination, ...response.data.pagination });
        setIsTableLoading(false);
    };

    const downloadReport = async () => {
        setIsDownloading(true);
        if (filters.created_at.length) {
            if (filters.created_at[1].diff(filters.created_at[0], "days") > 31){
                handleApiExceptions("This report can be downloaded for 31 days or less.");
                setIsDownloading(false);
                return;
            }
        }
        const response = await Ledger.download_report({ ...prepFilters(filters) });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        alertify(
            "Success",
            response?.data?.message || "Request generated Successfully",
            "confirm",
            {
                closable: true,
                cancelText: "Close",
                okText: "Go to Report Section",
                onOk: () => goTo(`/reports`, props.history),
                onCancel: () => { },
                icon: <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
            }
        );
        setIsDownloading(false);
    };


    const fetchConnectedBankStatements = async (_pagination, _filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await Ledger.list_connected_bank_statements({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        setLedgerData(response.data.results);
        setPagination({ ..._pagination, ...response.data.pagination });
        setIsTableLoading(false);
    };

    const downloadConnectedBankStatement = async (record) => {
        setIsTableLoading(true);
        const response = await Ledger.download_connected_bank_statement({ id: record.id });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        setIsTableLoading(false);
        window.open(response.data.url, '_blank');
    }

    const downloadMonthlyConnectedBankStatement = async (record) => {
        setIsDownloading(true)
        const response = await Ledger.download_monthly_connected_bank_statement({ ...prepFilters(filters) });
        if (!response.success) {
            setIsDownloading(false);
            handleApiExceptions(response);
            return;
        }
        setIsDownloading(false);
        window.open(response.data.url, '_blank');
    }

    const toggleLedgerDrawer = (ledger = {}) => {
        setActiveLedger(ledger);
        setShowLedgerDrawer(!showLedgerDrawer);
    }

    const fetchVirtualAccounts = async (merchant_id=props.current_user.id) => {
        setVirtualAccounts([]);
        let merchant = new Merchant({id: merchant_id})
        const response = await merchant.list_virtual_accounts()
        if (!response.success) {
            return;
        }
        setVirtualAccounts(response.data.virtual_accounts);
        let _currentVirtualAccount = (response.data.virtual_accounts || []).find(x => x.active) || {}
        setCurrentVirtualAccount(_currentVirtualAccount);
    };


    const [tableColumns, setTableColumns] = useState(getLedgerTableColumns({ currentVirtualAccount: currentVirtualAccount, downloadConnectedBankStatement: downloadConnectedBankStatement }))
    const [tableFilters, setTableFilters] = useState(ledgerTableFilterNodes(virtualAccounts, props.current_user.payment_modes, currentVirtualAccount, props.current_user));

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let filter_call = false;
        let _pagination = { ...pagination };
        let _currentVirtualAccount = currentVirtualAccount;
        if (tableInfo.trigger == "filters") {
            let _filters = tableInfo.filters;
            _pagination.current = 1;
            if(_filters?.submerchant_id != filters.submerchant_id){
                fetchVirtualAccounts(_filters.submerchant_id?_filters.submerchant_id:props.current_user.id);
                setPagination(_pagination);
                setFilters(tableInfo.filters);
                return
            }
            filter_call = true;
            if(_filters.virtual_account && filters.virtual_account != _filters.virtual_account){
                _currentVirtualAccount = (virtualAccounts || []).find(x => x.id == tableInfo.filters.virtual_account);
                if(_currentVirtualAccount?.is_connected_banking){
                    tableInfo.filters['year'] = moment().year();
                    tableInfo.filters['month'] = moment().month() + 1;
                }
                else{
                    tableInfo.filters['created_at'] = [moment().subtract(3, 'days'), moment()];
                }
                let _tableColumns = getLedgerTableColumns({ currentVirtualAccount: _currentVirtualAccount, downloadConnectedBankStatement: downloadConnectedBankStatement });
                setTableColumns(_tableColumns);
                setCurrentVirtualAccount(_currentVirtualAccount);            }
        }
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        if (_currentVirtualAccount?.is_connected_banking || _currentVirtualAccount?.is_bipatriate_escrow) {
            fetchConnectedBankStatements(_pagination, tableInfo.filters);
        }
        else {
            fetchLedgerData(_pagination, tableInfo.filters);
        }
    };


    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        if (currentVirtualAccount?.is_connected_banking || currentVirtualAccount?.is_bipatriate_escrow) {
            fetchConnectedBankStatements({ ..._pagination }, filters);
        }
        else {
            fetchLedgerData({ ..._pagination }, filters);
        }
    };

    useEffect(() => {
        props.onChildMount();

        let defaultFilters = {};
        tableFilters.forEach(f => defaultFilters[f.field] = f.defaultValue);
        let _filters = { ...filters, ...defaultFilters };
        setFilters(_filters);

        if (currentVirtualAccount?.is_connected_banking || currentVirtualAccount?.is_bipatriate_escrow) {
            fetchConnectedBankStatements({ ...pagination }, _filters)
        }
        else {
            fetchLedgerData({ ...pagination }, _filters);
        }
    }, []);

    useEffect(() => {
        let _tableFilters = ledgerTableFilterNodes(virtualAccounts, props.current_user.payment_modes, currentVirtualAccount, props.current_user);
        setTableFilters(_tableFilters);
    }, [currentVirtualAccount]);

    return (
        <ContentCard className="p-3">
            <div>
                <EaseTable
                    className="ledger-table-wrapper"
                    rowKey="uuid"
                    loading={isTableLoading}
                    data={ledgerData}
                    columns={tableColumns}
                    fixedSelectable={!isMobile}
                    handleTableChange={handleTableChange}
                    filterNodes={tableFilters}
                    downloadable={(currentVirtualAccount?.is_connected_banking||currentVirtualAccount?.is_bipatriate_escrow) ? filters.year && filters.month : permissions.includes("ACCOUNT_STATEMENT_DOWNLOAD_REPORT") && props.current_user.allow_dashboard_download}
                    onDownload={(currentVirtualAccount?.is_connected_banking||currentVirtualAccount?.is_bipatriate_escrow) ? downloadMonthlyConnectedBankStatement : downloadReport}
                    isDownloading={isDownloading}
                />
                <PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
            </div>
            <LedgerDrawer
                visible={showLedgerDrawer}
                ledger={activeLedger}
                toggleLedgerDrawer={toggleLedgerDrawer}
            />
        </ContentCard>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

export default connect(mapStateToProps)(PermissionHoc(LedgerList, 'ACCOUNT_STATEMENT_READ'));